import { render } from "./ComunidadRow.vue?vue&type=template&id=b06e8f66"
import script from "./ComunidadRow.vue?vue&type=script&lang=js"
export * from "./ComunidadRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__